import { GtagKeys } from 'constants/analytics';

export const setGtagClientId = () => {
    if (window.gtag) {
        window.gtag('get', 'G-72M2PQRMV1', 'client_id', (clientId: string) => {
            localStorage.setItem(GtagKeys.gtagClientId, clientId);
        });
    }
};
